/**
 * Classe usada para montar o elemento PicklistMultiselect.
 * Eh aquele que o usuario pode escolher varias opcoes em uma lista
 */

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PickListIcon = (function () {

    function PickListIcon (field, entity) {

        Monet.UI.Fields.TextField.apply (this, arguments);

        this.createBaseStructure ();

        this.iconOptions = field.iconOptions || App.Objects[entity].iconOptions || [];
        this.defaultValue = field.defaultValue || (this.iconOptions.length ? this.iconOptions[0] : '');
        this.value = this.defaultValue;


        this.getValue = function () {
            return this.selectedIconElement.className;
        };

        this.isEmpty = function () {
            return !this.selectedIconElement.className;
        };

        this.setValue = function (value) {

            const valueIsOnOptionsList = this.iconOptions.filter(iconName => iconName.includes(value));

            if(valueIsOnOptionsList.length) {
                this.value = value;
                this.selectedIconElement.innerHTML = "";
                this.selectedIconElement.id = 'selectedIconElement';
                this.selectedIconElement.className = this.value;
                this.selectedIconElement.setAttribute('title', Monet.I18n.getResourcesByKey(value));

                this.checkIconPaths(valueIsOnOptionsList[0], this.selectedIconElement)
            }
        };


        this.clear = function () {

            var valueOptions = this.input.selectedOptions;
            for(var i = 0, length = valueOptions.length; i < length;  i++) {
                valueOptions[i].selected = false;
            }
            this.value = [];

        };

        this.setOptions = function(iconOptions) {
            this.iconOptions = iconOptions;
            const createAndAddIcon = function(classItem){
                const icon = this.createIcon(classItem);

                this.listContainer.appendChild(icon);
            }.bind(this);

            this.iconOptions.forEach(createAndAddIcon);
            this.setValue(this.value);

        };

        this.createIcon = (classItem) => {
            const eventToSelectItem = (event) => {
                this.setValue(event.currentTarget.className);
                this.toogleIconOptionsState();
            };

            const icon = document.createElement('span');
            icon.className = classItem;
            icon.addEventListener('click', eventToSelectItem);

            return this.checkIconPaths(classItem, icon);;
        };

        this.checkIconPaths = (iconName, icon) => {
            const checkIconPaths = iconName.split(" ");
            if(checkIconPaths.length > 1) {
                icon.className = checkIconPaths[0];
                checkIconPaths.splice(0, 1);
                checkIconPaths.forEach( path => {
                    const iconPath = document.createElement('span');
                    iconPath.className = path;
                    icon.appendChild(iconPath);
                });
            }
            return icon;
        };

        this.toogleIconOptionsState = function() {
            var isOpen = this.listContainer.className.indexOf('open') !== -1 ;
            if(isOpen) {
                this.listContainer.className = this.listContainer.className.replace(' open', '');
            } else {
                this.listContainer.className += ' open';
                this.listContainer.focus();
            }

        };

        this.addEventListener = function () {

            const fn = function(e){
               this.toogleIconOptionsState(e);
            }.bind(this);

            this.selectedIconContainer.addEventListener('click', fn);
        };

        this.render = function () {

            this.container = document.createElement('div');
            this.selectedIconContainer = document.createElement('div');
            this.selectedIconElement = document.createElement('div');
            this.listContainer = document.createElement('div');
            this.listContainer.className = 'listContainer';
            this.selectedIconContainer.className = 'selected-container';
            this.selectedIconElement.className = 'selected-icon';
            this.listContainer.setAttribute('tabindex', "0");

            this.container.className = 'picklist-icon';

            this.addEventListener();

            this.setValue(this.defaultValue);
            this.selectedIconContainer.appendChild(this.selectedIconElement);
            this.container.appendChild(this.selectedIconContainer);
            this.container.appendChild(this.listContainer);
            this.rootEl.appendChild(this.container);

            if(this.iconOptions.length) {
                this.setOptions(this.iconOptions);
            }

            return this.rootEl;

        };

    }

    return PickListIcon;

}());
